import { connect, mapProps } from '@formily/react'
import {
  Select as UISelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

export interface SelectOption {
  label: string
  value: any
  disabled?: boolean
}

export interface FormilySelectProps {
  options?: SelectOption[]
  value?: any
  onChange?: (value: any) => void
  placeholder?: string
  className?: string
  disabled?: boolean
}

const InternalSelect = ({
  options = [],
  value,
  onChange,
  placeholder,
  className,
  disabled,
  ...props
}: FormilySelectProps) => {
  return (
    <UISelect
      value={value}
      onValueChange={onChange}
      disabled={disabled}
      {...props}
    >
      <SelectTrigger className={cn(className)}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </UISelect>
  )
}

export const FormilySelect = connect(
  InternalSelect,
  mapProps({
    dataSource: 'options',
    loading: true,
  }),
)
